import { validatePresence } from 'ember-changeset-validations/validators'

export const editClassValidator = {
  name: [validatePresence({ presence: true, ignoreBlank: true })],
}
